export default "__VITE_ASSET__EqHNaSqJ__"